import { render, staticRenderFns } from "./CrudMentorsList.vue?vue&type=template&id=15242ba4&"
import script from "./CrudMentorsList.vue?vue&type=script&lang=js&"
export * from "./CrudMentorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports